import { render, staticRenderFns } from "./n-box.vue?vue&type=template&id=2e6df7c4&scoped=true"
import script from "./n-box.vue?vue&type=script&lang=js"
export * from "./n-box.vue?vue&type=script&lang=js"
import style0 from "./n-box.vue?vue&type=style&index=0&id=2e6df7c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6df7c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6df7c4')) {
      api.createRecord('2e6df7c4', component.options)
    } else {
      api.reload('2e6df7c4', component.options)
    }
    module.hot.accept("./n-box.vue?vue&type=template&id=2e6df7c4&scoped=true", function () {
      api.rerender('2e6df7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/n-box/n-box.vue"
export default component.exports